<template>
    <div>
      <workflow-host :current-workflow="currentWorkflow"></workflow-host>

      <p class="copyright">© TalentSensus {{ appYear }} <el-button type="text" small @click="termsDialog = true">Terms and Conditions</el-button></p>
      <br />

      <el-dialog title="" :visible.sync="termsDialog" width="40%">
        <h4>Terms and Conditions</h4>
        <p><a href="/static/terms_conditions.pdf" download>Click here to download our Terms & Conditions</a></p>
      </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';

import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon.vue';

import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';

import WorkflowHost from '@/components/workflow/WorkflowHost.vue';
import workflow from '../router/workflow';

Vue.use(Element, { locale });

export default {
  name: 'login',
  components: { WorkflowHost },
  computed: {
    currentWorkflow() {
      return workflow;
    },
    appYear() {
      return process.env.VUE_APP_YEAR;
    },
  },
  data() {
    return {
      termsDialog: false
    };
  },
};
</script>

<style lang="scss">

</style>
